module.exports = __webpack_public_path__ + "static/04-f91f216f6dcccc296c646ccf71110979.jpg";